import { useToast } from '@/view/components/ui/use-toast'
import { ProposalData } from '..'
import { useQuery } from '@tanstack/react-query'
import { TransactionByIdResponse } from '@/app/services/transactionService/transactionById'
import { transactionsService } from '@/app/services/transactionService'

interface useProposalSuccessModalProps {
  proposalData: ProposalData
}

export default function useProposalSuccessModal({
  proposalData,
}: useProposalSuccessModalProps) {
  const { toast } = useToast()

  const { data, isLoading } = useQuery<TransactionByIdResponse>({
    queryKey: ['transactionId', proposalData?.propostaId],
    queryFn: ({ queryKey }) => {
      const [, id] = queryKey as [string, string]
      return transactionsService.transactionById(id)
    },
    enabled: !!proposalData?.propostaId,
  })

  const copyWhatsAppLink = () => {
    if (!data?.url) {
      toast({
        title: 'Não foi possível copiar o link.',
        description: 'A URL da proposta ainda não está disponível.',
        variant: 'destructive',
      })
      return
    }

    navigator.clipboard.writeText(data.url)

    toast({
      title: 'Link copiado com sucesso!',
    })
  }

  return { isLoading, copyWhatsAppLink }
}
